export default function (instance) {
  return {
    create(userId, config = {}) {
      return instance.post(`users/${userId}/zlto-wallet`, config);
    },
  };
}
